import React, { Component } from 'react';
import { FieldTypes, filterFieldsForForm } from 'drapcode-constant';
import TextField from './TextField';
import TextArea from './TextArea';
import Reference from './Reference';
import DynamicOptions from './DynamicOptions';
import BooleanField from './BooleanField';
import NumberField from './NumberField';
import DateTimeField from './DateTimeField';
import FileUploadField from './FileUploadField';
import ImageUploadField from './ImageUploadField';
import MultiImageUploadField from './MultiImageUploadField';
import StaticOptions from './StaticOptions';
import PhoneNumberField from './PhoneNumberField';
import EmailField from './EmailField';
//TODO: Refactor
const {
  email,
  tel,
  large_text,
  reference,
  dynamic_option,
  boolean,
  number,
  date,
  file,
  image,
  multi_image,
  static_option,
} = FieldTypes;
class ReferenceFieldForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      [this.props.field.fieldName]: {},
      options: [],
      refCollection: null,
      item: null,
      refFields: [],
    };
  }

  componentDidMount() {
    const refCollection = this.getReferenceCollection();
    this.setState({ refCollection: refCollection });
    const fields = refCollection ? filterFieldsForForm(refCollection.fields) : [];
    const refFields = fields.map((field) => {
      const copyField = Object.assign({}, field);
      copyField.fieldName = this.props.field.fieldName + '.' + field.fieldName;
      return copyField;
    });
    this.setState({ refFields });
  }

  getReferenceCollection = () => {
    const { collections } = this.props.collections;
    const { collectionName } = this.props.field.refCollection;
    return collections.length > 0
      ? collections.find((collection) => collection.collectionName === collectionName)
      : null;
  };

  render() {
    const {
      field,
      values,
      isConstructorForm,
      setFieldValue,
      projectId,
      version,
      collectionId,
      collections,
      setErrors,
      setSubmitting,
      plugins,
      s3Url,
    } = this.props;
    return (
      <div className="form-group">
        <label htmlFor={field.fieldName} className="col-form-label">
          {field.fieldTitle['en']}
          {field.required && !isConstructorForm ? ' *' : ''}
        </label>
        {this.state.refFields && this.state.refFields.length > 0
          ? this.state.refFields.map((field) => (
            <div className="form-group" key={field.fieldName}>
              {passwordField.includes(field.type) && <TextField field={field} key={field.uuid} />}
              {field.type === large_text.id && (
                <TextArea
                  setFieldValue={setFieldValue}
                  field={field}
                  values={values}
                  projectId={projectId}
                  key={field.uuid}
                  version={version}
                  s3Url={s3Url}
                />
              )}
              {field.type === reference.id && field.refCollection.displayType === 'dropdown' && (
                <Reference
                  key={field.uuid}
                  field={field}
                  setFieldValue={setFieldValue}
                  values={values}
                  version={version}
                  projectId={projectId}
                />
              )}
              {field.type === reference.id && field.refCollection.displayType === 'innerForm' && (
                <ReferenceFieldForm
                  key={field.uuid}
                  field={field}
                  setFieldValue={setFieldValue}
                  collections={collections}
                  values={values}
                  collectionId={collectionId}
                  projectId={projectId}
                  version={version}
                  setErrors={setErrors}
                  s3Url={s3Url}
                />
              )}
              {field.type === dynamic_option.id && (
                <DynamicOptions
                  key={field.uuid}
                  field={field}
                  setFieldValue={setFieldValue}
                  values={values}
                  projectId={projectId}
                  version={version}
                />
              )}
              {field.type === boolean.id && <BooleanField key={field.uuid} field={field} />}
              {field.type === number.id && <NumberField key={field.uuid} field={field} />}
              {field.type === date.id && (
                <DateTimeField
                  key={field.uuid}
                  field={field}
                  values={values}
                  setFieldValue={setFieldValue}
                  isConstructorForm={isConstructorForm}
                />
              )}
              {field.type === file.id && (
                <FileUploadField
                  key={field.uuid}
                  field={field}
                  setFieldValue={setFieldValue}
                  collectionId={this.props.field.refCollection.collectionName}
                  projectId={projectId}
                  version={version}
                  values={values}
                  setSubmitting={setSubmitting}
                  setErrors={setErrors}
                  plugins={plugins}
                />
              )}
              {field.type === image.id && (
                <ImageUploadField
                  key={field.uuid}
                  field={field}
                  setFieldValue={setFieldValue}
                  collectionId={collectionId}
                  values={values}
                  projectId={projectId}
                  plugins={plugins}
                  setSubmitting={setSubmitting}
                />
              )}
              {field.type === multi_image.id && (
                <MultiImageUploadField
                  key={field.uuid}
                  field={field}
                  setFieldValue={setFieldValue}
                  collectionId={collectionId}
                  values={values}
                  projectId={projectId}
                  plugins={plugins}
                  version={version}
                />
              )}
              {field.type === static_option.id && (
                <StaticOptions
                  key={field.uuid}
                  field={field}
                  setFieldValue={setFieldValue}
                  values={values}
                  projectId={projectId}
                />
              )}
              {field.type === tel.id && (
                <PhoneNumberField
                  field={field}
                  key={field.uuid}
                  values={values}
                  setFieldValue={setFieldValue}
                  isConstructorForm={isConstructorForm}
                />
              )}
              {field.type === email.id && (
                <EmailField
                  field={field}
                  key={field.uuid}
                  isConstructorForm={isConstructorForm}
                />
              )}
            </div>
          ))
          : ''}
      </div>
    );
  }
}

export default ReferenceFieldForm;
